module.exports = __webpack_public_path__ + "static/media/mainSlide4.46adc003.jpg";